const unauthorized = {
  title: 'Es ist ein Fehler aufgetreten',
  subtitle: 'Der Inhalt dieser Seite gehört zu einem anderen Kundenkonto. Sie sind leider nicht autorisiert auf den Inhalt zuzugreifen.',
  button: {
    startPage: 'Startseite',
    productSearch: 'Produktsuche',
    prescriptionUpload: '(E-)Rezept hochladen',
    login: 'Login',
    userAccount: 'Kundenkonto',
  },
}

export default unauthorized
